// // HTML titles
export const WHTML_005 = 'Débloquer et sécuriser votre compte Orange';
export const WHTML_006 = 'Débloquer et sécuriser votre compte Orange';
export const WHTML_007 = 'Votre nouveau mot de passe est enregistré';

// // Global titles
export const WLOST_001 = 'Débloquer et sécuriser votre compte Orange';
export const WLOST_006 = 'Débloquer et sécuriser votre compte Orange';

// // Stepbar
export const WLOST_013 = 'Déblocage de votre compte';

// // Update contacts
export const WLOST_500 = 'Vérifiez vos moyens de contacts';
export const WLOST_501 = 'Vos moyens de contact vous permettent de recevoir des notifications relatives à la sécurité de votre compte. Afin de garantir qu\'ils sont bien les vôtres, nous vous invitons à <strong>vérifier leur exactitude dès à présent</strong>.';
export const WBUTTON_002 = 'Continuer';

// // Confirmation
export const WLOST_600 = 'Votre nouveau mot de passe est enregistré';
export const WLOST_601 = 'Vous pouvez maintenant <strong>débloquer votre compte</strong>. Pour cela, <strong>veuillez vous identifier</strong> avec votre nouveau mot de passe.<br><br>Vous pourrez ensuite sécuriser votre compte en <strong>vérifiant vos informations personnelles</strong>.';
export const WLOST_603 = 'Débloquer votre compte';
